import Router from 'vue-router';
import Vue from 'vue';

const DynamicPages = () => import('./views/DynamicPages.vue');
const Home = () => import('./views/Home.vue');
const Login = () => import('./views/Login.vue');
const JobPost = () => import('./views/JobPost.vue');
const JobListingDetail = () => import('./views/JobListingDetail');
const JobListing = () => import('./views/JobListing');
const AcceptBid = () => import('./views/AcceptBid');
const PasswordReset = () => import('./views/PasswordResetConfirm');

Vue.use(Router);


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/pages/:slug',
      component: DynamicPages,
    },
    {
      path: '/postnewjob/:start/:end',
      component: JobPost,
      name: 'postnewjobwithpostcodes',
      props: true,
    },
    {
      path: '/postnewjob',
      component: JobPost,
      name: 'postnewjob',
    },
    {
      path: '/jobs',
      component: JobListing,
      name: 'jobs',
    },
    {
      path: '/viewjob/:jobuc',
      component: JobListingDetail,
      name: 'joblistingdetail',
      props: true,
    },
    {
      path: '/viewjob/',
      component: JobListing,
      name: 'joblistings',
      props: true,
    },
    {
      path: '/acceptbid/:unique_code/:action_key',
      component: AcceptBid,
      name: 'acceptbid',
      props: true,
    },
    {
      path: '/passwordconfirm/:uid/:token',
      component: PasswordReset,
      name: 'passwordreset',
      props: true,
    },
  ],
});
